export default __webpack_public_path__ + "static/media/zero_balance_portfolio.c2e030c7.svg";